// Deterministic waveform bars based on filename so each file looks unique
function hashBars(str, count) {
  const bars = [];
  for (let i = 0; i < count; i++) {
    let h = 0;
    for (let j = 0; j < str.length; j++) {
      h = (h * 31 + str.charCodeAt((i * 7 + j) % str.length)) >>> 0;
    }
    bars.push(25 + (h % 60)); // height 25–84%
  }
  return bars;
}

export default function AudioThumbnail({ filename = '', size = 'md' }) {
  const BAR_COUNT = size === 'sm' ? 12 : size === 'lg' ? 24 : 18;
  const bars = hashBars(filename || 'audio', BAR_COUNT);

  const iconSize = size === 'sm' ? 10 : size === 'lg' ? 18 : 13;
  const fontSize = size === 'sm' ? 8 : size === 'lg' ? 11 : 9;
  const label = (filename || 'audio').replace(/\.[^.]+$/, '');

  return (
    <div style={{
      width: '100%', height: '100%',
      background: 'linear-gradient(135deg, var(--brand-900) 0%, var(--brand-900) 50%, var(--brand-900) 100%)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      gap: size === 'sm' ? 4 : 6,
      padding: size === 'sm' ? '4px' : '8px',
      overflow: 'hidden',
    }}>
      {/* Waveform bars */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: size === 'sm' ? 1.5 : 2,
        height: size === 'sm' ? 20 : size === 'lg' ? 40 : 28,
        width: '80%',
      }}>
        {bars.map((h, i) => (
          <div
            key={i}
            style={{
              flex: 1,
              height: `${h}%`,
              borderRadius: 99,
              background: `rgba(129,140,248,${0.5 + (h / 84) * 0.5})`,
            }}
          />
        ))}
      </div>

      {/* Music icon + label */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="rgba(165,180,252,0.9)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 18V5l12-2v13" />
          <circle cx="6" cy="18" r="3" />
          <circle cx="18" cy="16" r="3" />
        </svg>
        <span style={{
          fontSize, color: 'rgba(199,210,254,0.8)',
          maxWidth: size === 'sm' ? 48 : size === 'lg' ? 100 : 70,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          lineHeight: 1,
        }}>
          {label}
        </span>
      </div>
    </div>
  );
}
